import { getApi, postApi, ErrorResponse } from './baseApi';
import { AUTH_ENDPOINTS } from '../constants/endpoints';

export interface StaffProfile {
  id: string;
  name: string;
  email: string;
  roles: string[];
  must_change_password: boolean;
}

// POST /staff/login and POST /staff/change-password answer this
export interface StaffLoginResponse {
  token: string;
  expires_at: string;
  must_change_password: boolean;
  staff: StaffProfile;
}

export const loginApi = (data: {
  email: string;
  password: string;
}): Promise<StaffLoginResponse | ErrorResponse> => postApi(AUTH_ENDPOINTS.LOGIN, data);

export const getMeApi = (): Promise<StaffProfile | ErrorResponse> => getApi(AUTH_ENDPOINTS.ME);

// Answers a new token: every older token of this user stops working
export const changePasswordApi = (data: {
  current_password: string;
  new_password: string;
}): Promise<StaffLoginResponse | ErrorResponse> => postApi(AUTH_ENDPOINTS.CHANGE_PASSWORD, data);

// 204; ends every token of the user (all devices)
export const logoutApi = (): Promise<any | ErrorResponse> => postApi(AUTH_ENDPOINTS.LOGOUT);
